import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';

// No `toJSON()`: a DELETE carries no body.
class ClearModelAssignment {
	constructor(
		public readonly scope: AssignmentScope,
		public readonly usage: string,
	) {
		Object.freeze(this);
	}
}

export default ClearModelAssignment;
